import type { Bundle } from '../types'

/** Paris & jeux : tableau de bord, tests de paiement, services, référentiels. */
export const betting = {
  // Gravités
  'bet.sev.COMPLIANT': { fr: 'Conforme', en: 'Compliant' },
  'bet.sev.TECHNICAL_ISSUE': { fr: 'Problème technique', en: 'Technical issue' },
  'bet.sev.LOW': { fr: 'Faible', en: 'Low' },
  'bet.sev.MEDIUM': { fr: 'Moyenne', en: 'Medium' },
  'bet.sev.HIGH': { fr: 'Haute', en: 'High' },
  'bet.sev.UNQUALIFIED': { fr: 'À qualifier', en: 'To qualify' },
  'bet.sev.notQualified': { fr: 'Pas encore qualifiés', en: 'Not yet qualified' },

  // Manquements
  'bet.breach.UNAUTHORISED_AGGREGATOR': { fr: 'Agrégateur non autorisé', en: 'Unauthorised aggregator' },
  'bet.breach.PROHIBITED_SERVICE': { fr: 'Service interdit dans le pays', en: 'Service prohibited in the country' },
  'bet.breach.UNLICENSED_OPERATOR': { fr: 'Opérateur sans licence', en: 'Unlicensed operator' },
  'bet.breach.UNAUTHORISED_BRAND_USE': {
    fr: 'Moyen de paiement sans autorisation',
    en: 'Payment method used without authorisation',
  },
  'bet.breach.NON_COMPLIANT_ADVERTISING': { fr: 'Publicité non conforme', en: 'Non-compliant advertising' },
  'bet.breach.TECHNICAL_ISSUE': { fr: 'Problème technique', en: 'Technical issue' },
  'bet.breach.OTHER': { fr: 'Autre', en: 'Other' },

  // Déroulé d'un parcours
  'bet.run.PENDING': { fr: 'En attente', en: 'Pending' },
  'bet.run.RUNNING': { fr: 'Parcours en cours', en: 'Journey running' },
  'bet.run.COMPLETED': { fr: 'Parcours terminé', en: 'Journey complete' },
  'bet.run.BLOCKED': { fr: 'Parcours bloqué', en: 'Journey blocked' },
  'bet.run.GEO_BLOCKED': { fr: 'Pays bloqué par le site', en: 'Country blocked by the site' },
  'bet.run.FAILED': { fr: 'Parcours en échec', en: 'Journey failed' },

  'bet.source.AUTO': { fr: 'Robot', en: 'Crawler' },
  'bet.source.MANUAL': { fr: 'Agent', en: 'Agent' },
  'bet.source.autoLower': { fr: 'robot', en: 'crawler' },
  'bet.source.manualLower': { fr: 'agent', en: 'agent' },

  'bet.depth.METHOD_SELECTION': {
    fr: "Jusqu'au choix du moyen de paiement",
    en: 'Up to the choice of payment method',
  },
  'bet.depth.PAYMENT_REQUEST': {
    fr: "Jusqu'à la demande de paiement (avant code PIN)",
    en: 'Up to the payment request (before the PIN)',
  },

  'bet.agg.AUTHORIZED': { fr: 'Autorisé', en: 'Authorised' },
  'bet.agg.UNAUTHORIZED': { fr: 'Non autorisé', en: 'Not authorised' },
  'bet.agg.UNKNOWN': { fr: 'À qualifier', en: 'To qualify' },

  // Preuves et données de démonstration
  'bet.evidenceMissing': { fr: 'Preuve indisponible', en: 'Evidence unavailable' },
  'bet.evidenceNone': { fr: 'Pas de capture', en: 'No screenshot' },
  'bet.evidenceLoading': { fr: 'Chargement de la capture', en: 'Loading the screenshot' },
  'bet.evidenceZoom': { fr: 'Agrandir : {alt}', en: 'Enlarge: {alt}' },
  'bet.fixtureToggle': { fr: 'Afficher les données de démonstration', en: 'Show demonstration data' },
  'bet.fixtureToggleHint': {
    fr: 'Services et tests adossés aux sites factices, exclus des chiffres',
    en: 'Services and tests backed by dummy websites, excluded from the figures',
  },
  'bet.fixtureBadge': { fr: 'Démo', en: 'Demo' },
  'bet.fixtureBadgeHint': {
    fr: 'Donnée de démonstration : exclue des chiffres',
    en: 'Demonstration data: excluded from the figures',
  },

  // Tableau de bord
  'bet.dashTitle': { fr: 'Conformité des sites de paris', en: 'Betting website compliance' },
  'bet.dashDesc': {
    fr: 'Parcours de paiement testés sur les {period}, {perimeter}.',
    en: 'Payment journeys tested over the {period}, {perimeter}.',
  },
  'bet.allScopeCountries': {
    fr: 'tous les pays de votre périmètre',
    en: 'every country within your scope',
  },
  'bet.manualTest': { fr: 'Saisir un test manuel', en: 'Record a manual test' },
  'bet.findSites': { fr: 'Rechercher des sites', en: 'Find websites' },
  'bet.kpiTests': { fr: 'Tests réalisés', en: 'Tests carried out' },
  'bet.kpiTestsSub': {
    fr: '{robot} par le robot · {agents} par les agents',
    en: '{robot} by the crawler · {agents} by agents',
  },
  'bet.kpiNotCompliant': { fr: 'Non conformes', en: 'Non-compliant' },
  'bet.kpiNotCompliantSub': {
    fr: ['{n} test, dont {high} en gravité haute', '{n} tests, dont {high} en gravité haute'],
    en: ['{n} test, {high} of high severity', '{n} tests, {high} of high severity'],
  },
  'bet.kpiOpen': { fr: 'Dossiers ouverts', en: 'Open cases' },
  'bet.kpiOpenSub': { fr: '{n} clos sur la période', en: '{n} closed over the period' },
  'bet.kpiToQualify': { fr: 'À qualifier', en: 'To qualify' },
  'bet.kpiToQualifySub': {
    fr: 'bénéficiaires ou domaines inconnus',
    en: 'unknown payees or domains',
  },
  'bet.priorityTitle': { fr: 'À traiter en priorité', en: 'Handle first' },
  'bet.prioritySub': { fr: 'Gravité haute, sans décision', en: 'High severity, no decision yet' },
  'bet.seeCases': { fr: ['Voir le {n} dossier', 'Voir les {n} dossiers'], en: ['See the {n} case', 'See all {n} cases'] },
  'bet.noPriority': {
    fr: 'Aucun dossier de gravité haute en attente de décision.',
    en: 'No high-severity case awaiting a decision.',
  },
  'bet.testNumber': { fr: 'Test n° {n}', en: 'Test no. {n}' },
  'bet.breachToSpecify': { fr: 'Infraction à préciser', en: 'Breach to be specified' },
  'bet.severityBlock': { fr: 'Conformité par gravité', en: 'Compliance by severity' },
  'bet.donutAria': { fr: '{compliant} conformes sur {total} tests', en: '{compliant} compliant out of {total} tests' },
  'bet.donutCenter': { fr: 'conformes', en: 'compliant' },
  'bet.breachesBlock': { fr: 'Infractions relevées', en: 'Breaches found' },
  'bet.noBreach': { fr: 'Aucune infraction sur la période.', en: 'No breach over the period.' },
  'bet.aggregatorsBlock': { fr: 'Agrégateurs qui encaissent', en: 'Aggregators collecting the money' },
  'bet.aggregatorsBlockSub': {
    fr: "Tests où l'agrégateur a été identifié",
    en: 'Tests where the aggregator was identified',
  },
  'bet.referentialLink': { fr: 'Référentiel', en: 'Reference data' },
  'bet.noAggregator': {
    fr: 'Aucun agrégateur identifié sur la période.',
    en: 'No aggregator identified over the period.',
  },
  'bet.notCompliantCount': { fr: ['{n} non conforme', '{n} non conformes'], en: ['{n} non-compliant', '{n} non-compliant'] },
  'bet.testCount': { fr: ['{n} test', '{n} tests'], en: ['{n} test', '{n} tests'] },

  // Liste des tests
  'bet.testsTitle': { fr: 'Tests de paiement', en: 'Payment tests' },
  'bet.testsDesc': {
    fr: 'Chaque test retrace un dépôt sur un site de paris : parcours, moyen de paiement, bénéficiaire réel et décision.',
    en: 'Each test retraces a deposit on a betting website: journey, payment method, actual payee and decision.',
  },
  'bet.testsHeading': { fr: 'Tests', en: 'Tests' },
  'bet.activeFilters': { fr: ['{n} filtre actif', '{n} filtres actifs'], en: ['{n} active filter', '{n} active filters'] },
  'bet.testSearchPlaceholder': {
    fr: 'N° de test, service, adresse ou société',
    en: 'Test no., service, address or company',
  },
  'bet.testSearchAria': { fr: 'Rechercher un test', en: 'Search for a test' },
  'bet.noTestMatch': {
    fr: 'Aucun test pour ces critères. Élargissez la période ou lancez une détection depuis « Services de paris ».',
    en: 'No test matches these criteria. Widen the period, or start a detection from “Betting services”.',
  },
  'bet.colSeverity': { fr: 'Gravité', en: 'Severity' },
  'bet.colService': { fr: 'Service', en: 'Service' },
  'bet.colBreach': { fr: 'Infraction', en: 'Breach' },
  'bet.colAggregators': { fr: 'Agrégateurs', en: 'Aggregators' },
  'bet.colRunBy': { fr: 'Réalisé par', en: 'Run by' },
  'bet.colTriage': { fr: 'Traitement', en: 'Triage' },
  'bet.testMeta': { fr: 'n° {n} · {country}', en: 'no. {n} · {country}' },
  'bet.notAssigned': { fr: 'Non attribué', en: 'Unassigned' },
  'bet.filtersAria': { fr: 'Filtres des tests', en: 'Test filters' },
  'bet.filterAllF': { fr: 'Toutes', en: 'All' },
  'bet.filterAllM': { fr: 'Tous', en: 'All' },
  'bet.filterNotClosed': { fr: 'Non clos', en: 'Not closed' },
  'bet.filterCarrier': { fr: 'Opérateur', en: 'Carrier' },
  'bet.filterAggregator': { fr: 'Agrégateur', en: 'Aggregator' },
  'bet.clearFilters': { fr: 'Effacer les filtres', en: 'Clear filters' },

  // Saisie d'un test manuel
  'bet.manualTitle': { fr: 'Saisir un test manuel', en: 'Record a manual test' },
  'bet.manualSub': {
    fr: 'Réalisez l’opération sur un téléphone, puis déposez les captures et collez le SMS de confirmation dans la fiche du test.',
    en: 'Carry out the operation on a phone, then upload the screenshots and paste the confirmation SMS into the test record.',
  },
  'bet.createTest': { fr: 'Créer le test', en: 'Create the test' },
  'bet.creating': { fr: 'Création…', en: 'Creating…' },
  'bet.direction': { fr: "Sens de l'opération", en: 'Direction of the operation' },
  'bet.directionDeposit': { fr: 'Dépôt — du joueur vers le site', en: 'Deposit — player to website' },
  'bet.directionWithdrawal': { fr: 'Retrait — du site vers le joueur', en: 'Withdrawal — website to player' },
  'bet.withdrawalHintA': {
    fr: 'Sur un retrait, le nom qui apparaît est celui qui',
    en: 'On a withdrawal, the name shown is the one that',
  },
  'bet.withdrawalHintVerb': { fr: 'verse', en: 'pays out' },
  'bet.withdrawalHintB': {
    fr: "l’argent, pas celui qui encaisse : il est conservé dans le dossier mais n’alimente pas le référentiel des encaisseurs.",
    en: 'the money, not the one collecting it: it is kept in the case file but does not feed the collectors reference data.',
  },
  'bet.serviceTested': { fr: 'Service testé', en: 'Service tested' },
  'bet.pickService': { fr: 'Choisir un service', en: 'Pick a service' },
  'bet.carrier': { fr: 'Opérateur télécom', en: 'Mobile carrier' },
  'bet.notSpecified': { fr: 'Non précisé', en: 'Not specified' },
  'bet.channel': { fr: 'Canal', en: 'Channel' },
  'bet.channelWeb': { fr: 'Web', en: 'Web' },
  'bet.channelApp': { fr: 'Application', en: 'App' },
  'bet.channelSms': { fr: 'SMS', en: 'SMS' },
  'bet.channelSocial': { fr: 'Réseau social', en: 'Social media' },
  'bet.connection': { fr: 'Connexion', en: 'Connection' },
  'bet.connectionMobile': { fr: 'Données mobiles', en: 'Mobile data' },
  'bet.connectionWifi': { fr: 'Wifi', en: 'Wi-Fi' },

  // Fiche d'un test
  'bet.allTests': { fr: '← Tous les tests', en: '← All tests' },
  'bet.prevTest': { fr: 'Test précédent', en: 'Previous test' },
  'bet.nextTest': { fr: 'Test suivant', en: 'Next test' },
  'bet.print': { fr: 'Imprimer la fiche', en: 'Print the record' },
  'bet.ticket': { fr: 'Ticket de surveillance (PDF)', en: 'Monitoring ticket (PDF)' },
  'bet.ticketBusy': { fr: 'Préparation…', en: 'Preparing…' },
  'bet.serviceFallback': { fr: 'Service', en: 'Service' },
  'bet.testedOn': { fr: 'Testé le', en: 'Tested on' },
  'bet.runningNote': {
    fr: 'Le robot parcourt le site. Les étapes apparaissent ici au fil de la détection.',
    en: 'The crawler is walking the website. Steps appear here as the detection runs.',
  },
  'bet.runUnfinished': { fr: 'Le parcours ne s’est pas terminé.', en: 'The journey did not complete.' },
  'bet.summaryPayee': {
    fr: 'Le dépôt{method} est encaissé par {payee}{status}.',
    en: 'The deposit{method} is collected by {payee}{status}.',
  },
  'bet.summaryAggUnauthorized': { fr: ', agrégateur non autorisé', en: ', an unauthorised aggregator' },
  'bet.summaryAggAuthorized': { fr: ', agrégateur autorisé', en: ', an authorised aggregator' },
  'bet.summaryRouted': {
    fr: 'Paiement orienté vers {name}, agrégateur non autorisé.',
    en: 'Payment routed to {name}, an unauthorised aggregator.',
  },
  'bet.summaryDetecting': { fr: 'Détection en cours.', en: 'Detection in progress.' },
  'bet.summaryMethods': {
    fr: 'Moyens de paiement proposés : {methods}.',
    en: 'Payment methods offered: {methods}.',
  },
  'bet.summaryEmpty': {
    fr: 'Pas encore de constat : complétez le parcours et la décision.',
    en: 'No finding yet: complete the journey and the decision.',
  },
  'bet.serviceBlock': { fr: 'Service testé', en: 'Service tested' },
  'bet.serviceRecord': { fr: 'Fiche du service', en: 'Service record' },
  'bet.runByRobotLogged': { fr: 'Robot, connecté au compte de test', en: 'Crawler, signed in to the test account' },
  'bet.runByRobotAnon': { fr: 'Robot, sans connexion', en: 'Crawler, not signed in' },
  'bet.runByAgent': { fr: 'Agent — {who}', en: 'Agent — {who}' },
  'bet.journeyDepth': { fr: 'Profondeur du parcours', en: 'Journey depth' },
  'bet.tracesBlock': { fr: 'Traces techniques', en: 'Technical traces' },
  'bet.tracesSub': {
    fr: '{urls} adresses visitées · {domains} domaines tiers contactés',
    en: '{urls} addresses visited · {domains} third-party domains contacted',
  },
  'bet.pagesVisited': { fr: 'Pages traversées', en: 'Pages visited' },
  'bet.noPageRecorded': { fr: 'Aucune page enregistrée.', en: 'No page recorded.' },
  'bet.thirdPartyDomains': { fr: 'Domaines tiers contactés', en: 'Third-party domains contacted' },
  'bet.noThirdParty': { fr: 'Aucun domaine tiers relevé.', en: 'No third-party domain found.' },
  'bet.robotReport': { fr: 'Compte rendu du robot', en: 'Crawler report' },
  'bet.sideAria': { fr: 'Décision et traitement', en: 'Decision and triage' },
  'bet.copied': { fr: 'Copiée', en: 'Copied' },

  // Décision
  'bet.decisionBlock': { fr: 'Décision', en: 'Decision' },
  'bet.noBreachOption': { fr: 'Aucune', en: 'None' },
  'bet.finding': { fr: 'Constat', en: 'Finding' },
  'bet.findingPlaceholder': {
    fr: 'Ce qui a été constaté, contexte, suites à donner.',
    en: 'What was found, the context, and what should follow.',
  },
  'bet.saveFinding': { fr: 'Enregistrer le constat', en: 'Save the finding' },
  'bet.assessedByRobot': {
    fr: 'Proposée automatiquement par le robot, modifiable.',
    en: 'Proposed automatically by the crawler; you can change it.',
  },
  'bet.assessedBy': { fr: 'Qualifiée par {who}', en: 'Qualified by {who}' },
  'bet.notAssessed': { fr: 'Pas encore qualifiée.', en: 'Not qualified yet.' },

  // Traitement
  'bet.treatmentBlock': { fr: 'Traitement', en: 'Triage' },
  'bet.transitionLabel': {
    fr: '{from} → {to} · motif {requirement}',
    en: '{from} → {to} · reason {requirement}',
  },
  'bet.required': { fr: '(obligatoire)', en: '(required)' },
  'bet.optional': { fr: '(facultatif)', en: '(optional)' },
  'bet.reasonKeptHistory': {
    fr: 'Ce motif est conservé dans l’historique.',
    en: 'This reason is kept in the history.',
  },
  'bet.validate': { fr: 'Valider', en: 'Confirm' },
  'bet.historyBlock': { fr: 'Historique', en: 'History' },
  'bet.testCreated': { fr: 'Test créé', en: 'Test created' },

  // Parcours et preuves
  'bet.journeyBlock': { fr: 'Parcours de paiement', en: 'Payment journey' },
  'bet.journeySub': {
    fr: ['{n} étape · {who}', '{n} étapes · {who}'],
    en: ['{n} step · {who}', '{n} steps · {who}'],
  },
  'bet.journeyByRobot': { fr: 'réalisé par le robot', en: 'run by the crawler' },
  'bet.journeyByAgent': { fr: 'réalisé par un agent, sur téléphone', en: 'run by an agent, on a phone' },
  'bet.captionPlaceholder': {
    fr: 'Légende (ex. : SMS de confirmation)',
    en: 'Caption (e.g. confirmation SMS)',
  },
  'bet.captionAria': { fr: 'Légende de la capture', en: 'Screenshot caption' },
  'bet.addCapture': { fr: 'Ajouter une capture', en: 'Add a screenshot' },
  'bet.uploading': { fr: 'Envoi…', en: 'Uploading…' },
  'bet.noStepRobot': { fr: 'Aucune étape capturée pour le moment.', en: 'No step captured yet.' },
  'bet.noStepAgent': {
    fr: 'Déposez les captures du parcours réalisé sur le téléphone, dans l’ordre.',
    en: 'Upload the screenshots of the journey run on the phone, in order.',
  },
  'bet.stepAlt': { fr: 'Étape {n} : {label}', en: 'Step {n}: {label}' },
  'bet.stepMoveUp': { fr: "Avancer l'étape {n}", en: 'Move step {n} earlier' },
  'bet.stepMoveDown': { fr: "Reculer l'étape {n}", en: 'Move step {n} later' },
  'bet.stepLabel': { fr: 'Étape {n}', en: 'Step {n}' },
  'bet.prevCapture': { fr: '← Précédente', en: '← Previous' },
  'bet.nextCapture': { fr: 'Suivante →', en: 'Next →' },
  'bet.agentCapture': { fr: 'Capture déposée par un agent', en: 'Screenshot uploaded by an agent' },

  // Paiement
  'bet.paymentBlock': { fr: 'Paiement', en: 'Payment' },
  'bet.smsEvidence': { fr: 'Preuve : SMS de confirmation', en: 'Evidence: confirmation SMS' },
  'bet.noSms': { fr: 'Aucun SMS de confirmation enregistré', en: 'No confirmation SMS recorded' },
  'bet.closeEntry': { fr: 'Fermer la saisie', en: 'Close the form' },
  'bet.editSms': { fr: 'Modifier le SMS', en: 'Edit the SMS' },
  'bet.pasteSms': { fr: 'Coller le SMS', en: 'Paste the SMS' },
  'bet.paymentMethod': { fr: 'Moyen de paiement', en: 'Payment method' },
  'bet.alsoOffered': { fr: 'Également proposés : {methods}', en: 'Also offered: {methods}' },
  'bet.actualPayee': { fr: 'Bénéficiaire réel', en: 'Actual payee' },
  'bet.amount': { fr: 'Montant', en: 'Amount' },
  'bet.smsLabel': {
    fr: 'SMS de confirmation — le bénéficiaire et le montant sont lus automatiquement, puis rapprochés du référentiel.',
    en: 'Confirmation SMS — the payee and the amount are read automatically, then matched against the reference data.',
  },
  'bet.smsPlaceholder': {
    fr: 'Ex. : Pay 450,00 FCFA TECH MINERVE TECH on 07/04/2026 18:29:48…',
    en: 'E.g. Pay 450.00 XOF TECH MINERVE TECH on 07/04/2026 18:29:48…',
  },
  'bet.payee': { fr: 'Bénéficiaire', en: 'Payee' },
  'bet.payeeFromSms': { fr: 'Lu dans le SMS', en: 'Read from the SMS' },
  'bet.amountPlaceholder': { fr: 'Ex. : 450,00 FCFA', en: 'E.g. 450.00 XOF' },
  'bet.aggIdentified': { fr: 'Agrégateurs identifiés', en: 'Aggregators identified' },
  'bet.noAggIdentified': {
    fr: 'Aucun agrégateur identifié. Les domaines et bénéficiaires inconnus sont dans « À qualifier ».',
    en: 'No aggregator identified. Unknown domains and payees are under “To qualify”.',
  },

  // Services de paris
  'bet.servicesTitle': { fr: 'Services de paris', en: 'Betting services' },
  'bet.servicesDesc': {
    fr: 'Sites de paris surveillés et paramètres du parcours automatique.',
    en: 'Monitored betting websites and automatic journey settings.',
  },
  'bet.servicesCount': {
    fr: ['{n} service surveillé · {accounts} avec compte de test · {stale} sans test depuis 30 jours', '{n} services surveillés · {accounts} avec compte de test · {stale} sans test depuis 30 jours'],
    en: ['{n} service monitored · {accounts} with a test account · {stale} untested for 30 days', '{n} services monitored · {accounts} with a test account · {stale} untested for 30 days'],
  },
  'bet.addService': { fr: 'Ajouter un service', en: 'Add a service' },
  'bet.noService': {
    fr: 'Aucun service de paris. Ajoutez-en un pour lancer la détection du parcours de paiement.',
    en: 'No betting service. Add one to start detecting the payment journey.',
  },
  'bet.noServiceInCountry': {
    fr: 'Aucun service de paris dans ce pays. Ajoutez-en un pour lancer la détection du parcours de paiement.',
    en: 'No betting service in this country. Add one to start detecting the payment journey.',
  },
  'bet.colAccess': { fr: 'Accès', en: 'Access' },
  'bet.colControl': { fr: 'Contrôle', en: 'Checks' },
  'bet.colLastTest': { fr: 'Dernier test', en: 'Last test' },
  'bet.companyUnknown': { fr: 'Société non renseignée', en: 'Company not recorded' },
  'bet.disabledSuffix': { fr: ' · désactivé', en: ' · disabled' },
  'bet.testAccount': { fr: 'Compte de test', en: 'Test account' },
  'bet.publicPages': { fr: 'Pages publiques', en: 'Public pages' },
  'bet.neverTested': { fr: 'Jamais testé', en: 'Never tested' },
  'bet.freqManual': { fr: 'Manuel', en: 'Manual' },
  'bet.freqDaily': { fr: 'Tous les jours', en: 'Every day' },
  'bet.freqWeekly': { fr: 'Chaque semaine', en: 'Every week' },
  'bet.freqFortnightly': { fr: 'Toutes les deux semaines', en: 'Every two weeks' },
  'bet.freqMonthly': { fr: 'Chaque mois', en: 'Every month' },
  'bet.freqEveryNDays': { fr: 'Tous les {n} jours', en: 'Every {n} days' },
  'bet.freqManualOnly': { fr: 'Manuel uniquement', en: 'Manual only' },
  'bet.nextPass': { fr: 'À la prochaine passe', en: 'At the next pass' },
  'bet.detectJourney': { fr: 'Détecter le parcours', en: 'Detect the journey' },
  'bet.launching': { fr: 'Lancement…', en: 'Starting…' },
  'bet.serviceDisabled': {
    fr: "Service désactivé : il n'est plus contrôlé automatiquement.",
    en: 'Service disabled: it is no longer checked automatically.',
  },
  'bet.addresses': { fr: 'Adresses', en: 'Addresses' },
  'bet.addressMain': { fr: 'Principale', en: 'Main' },
  'bet.addressMirror': { fr: 'Miroir', en: 'Mirror' },
  'bet.autoJourney': { fr: 'Parcours automatique', en: 'Automatic journey' },
  'bet.depthField': { fr: 'Profondeur', en: 'Depth' },
  'bet.depositPath': { fr: 'Chemin vers le dépôt', en: 'Path to the deposit page' },
  'bet.depositPathAuto': { fr: 'Détecté seul', en: 'Detected automatically' },
  'bet.nextCheck': { fr: 'Prochain contrôle', en: 'Next check' },
  'bet.testAmount': { fr: 'Montant de test', en: 'Test amount' },
  'bet.testAccountsSection': { fr: 'Comptes de test', en: 'Test accounts' },
  'bet.manageAccounts': { fr: 'Gérer les comptes', en: 'Manage the accounts' },
  'bet.noAccountRobot': {
    fr: 'Aucun compte : le robot reste sur les pages publiques du site.',
    en: 'No account: the crawler stays on the website’s public pages.',
  },
  'bet.accountUsername': { fr: 'Identifiant {username}', en: 'Username {username}' },
  'bet.accountSim': { fr: ' · SIM {phone}', en: ' · SIM {phone}' },
  'bet.accountDisabled': { fr: 'Désactivé', en: 'Disabled' },
  'bet.accountNeverUsed': { fr: 'Jamais utilisé', en: 'Never used' },
  'bet.accountUsedOn': { fr: 'Utilisé le {date}', en: 'Used on {date}' },
  'bet.lastTests': { fr: 'Derniers tests', en: 'Latest tests' },
  'bet.allTestsLink': { fr: 'Tous les tests', en: 'All tests' },
  'bet.neverTestedDot': { fr: 'Jamais testé.', en: 'Never tested.' },
  'bet.serviceFormEdit': { fr: 'Modifier {name}', en: 'Edit {name}' },
  'bet.serviceFormNew': { fr: 'Ajouter un service de paris', en: 'Add a betting service' },
  'bet.addServiceSubmit': { fr: 'Ajouter le service', en: 'Add the service' },
  'bet.serviceName': { fr: 'Nom du service', en: 'Service name' },
  'bet.serviceNamePlaceholder': { fr: 'Ex. : 1xBet', en: 'E.g. 1xBet' },
  'bet.operatorCompany': { fr: 'Société exploitante', en: 'Operating company' },
  'bet.operatorPlaceholder': { fr: 'Ex. : SAS Ludus', en: 'E.g. Ludus Ltd' },
  'bet.mainAddress': { fr: 'Adresse principale', en: 'Main address' },
  'bet.mirrorAddresses': { fr: 'Adresses miroirs (une par ligne)', en: 'Mirror addresses (one per line)' },
  'bet.mirrorHint': {
    fr: "Utilisées si l'adresse principale est bloquée.",
    en: 'Used if the main address is blocked.',
  },
  'bet.hintsField': {
    fr: 'Chemin vers le dépôt (facultatif, un bouton par ligne)',
    en: 'Path to the deposit page (optional, one button per line)',
  },
  'bet.hintsHint': {
    fr: "À renseigner seulement si la détection ne trouve pas la page de dépôt seule : libellés des boutons à cliquer, dans l'ordre.",
    en: 'Only needed when detection cannot find the deposit page on its own: the labels of the buttons to click, in order.',
  },
  'bet.hintsPlaceholder': { fr: 'Dépôt\nMobile Money', en: 'Deposit\nMobile Money' },
  'bet.depthLegend': { fr: "Jusqu'où va le robot", en: 'How far the crawler goes' },
  'bet.depthMethodHint': {
    fr: "Il ouvre le dépôt et chaque moyen de paiement mobile. Aucune transaction n'est initiée.",
    en: 'It opens the deposit page and each mobile payment method. No transaction is started.',
  },
  'bet.depthRequestHint': {
    fr: "Il saisit un montant et le numéro de la SIM de test, puis soumet : une demande de paiement en attente est créée. Il ne saisit jamais de code PIN.",
    en: 'It enters an amount and the test SIM number, then submits: a pending payment request is created. It never enters a PIN.',
  },
  'bet.amountWarning': {
    fr: 'Nécessite un compte de test avec un numéro de SIM de test. Chaque contrôle crée une demande de paiement sur ce numéro.',
    en: 'Requires a test account with a test SIM number. Each check creates a payment request on that number.',
  },
  'bet.amountPlaceholderSimple': { fr: 'Ex. : 200', en: 'E.g. 200' },
  'bet.autoCheck': { fr: 'Contrôle automatique', en: 'Automatic check' },
  'bet.serviceWatched': { fr: 'Service surveillé', en: 'Service monitored' },

  // Comptes de test
  'bet.accountsTitle': { fr: 'Comptes de test — {name}', en: 'Test accounts — {name}' },
  'bet.accountsSub': {
    fr: 'Créez le compte vous-même sur le site, puis déclarez-le ici. Les identifiants sont chiffrés et ne sont plus jamais affichés en clair.',
    en: 'Create the account yourself on the website, then record it here. Credentials are encrypted and never shown in clear again.',
  },
  'bet.noAccount': {
    fr: 'Aucun compte : le robot restera sur les pages publiques du site.',
    en: 'No account: the crawler will stay on the website’s public pages.',
  },
  'bet.accountUsedWith': { fr: 'Utilisé le {date} — {result}', en: 'Used on {date} — {result}' },
  'bet.declareAccount': { fr: 'Déclarer un compte', en: 'Record an account' },
  'bet.accountLabel': { fr: 'Libellé', en: 'Label' },
  'bet.accountLabelPlaceholder': {
    fr: 'Ex. : Compte agent Libreville',
    en: 'E.g. Libreville agent account',
  },
  'bet.username': { fr: 'Identifiant', en: 'Username' },
  'bet.loginPage': { fr: 'Page de connexion (facultatif)', en: 'Sign-in page (optional)' },
  'bet.testSim': { fr: 'Numéro de la SIM de test (facultatif)', en: 'Test SIM number (optional)' },
  'bet.saveAccount': { fr: 'Enregistrer le compte', en: 'Save the account' },
  'bet.deleteAccountConfirm': {
    fr: 'Supprimer le compte « {label} » ? Ses identifiants seront effacés.',
    en: 'Delete the account “{label}”? Its credentials will be erased.',
  },

  // À qualifier
  'bet.qualifyTitle': { fr: 'À qualifier', en: 'To qualify' },
  'bet.qualifyDesc': {
    fr: 'Bénéficiaires et domaines vus pendant les tests que le référentiel ne reconnaît pas encore. Chaque décision enrichit le référentiel et requalifie les tests concernés.',
    en: 'Payees and domains seen during tests that the reference data does not recognise yet. Each decision enriches the reference data and re-qualifies the affected tests.',
  },
  'bet.candidateStatus': { fr: 'Statut des éléments', en: 'Status of the items' },
  'bet.candPending': { fr: 'En attente', en: 'Pending' },
  'bet.candLinked': { fr: 'Rattachés', en: 'Linked' },
  'bet.candIgnored': { fr: 'Écartés', en: 'Set aside' },
  'bet.qualifyEmptyPending': {
    fr: 'Rien à qualifier : tous les bénéficiaires et domaines relevés sont reconnus.',
    en: 'Nothing to qualify: every payee and domain found is recognised.',
  },
  'bet.qualifyEmpty': { fr: 'Aucun élément.', en: 'No item.' },
  'bet.candBeneficiary': { fr: 'Bénéficiaire lu dans un SMS', en: 'Payee read from an SMS' },
  'bet.candDomain': { fr: 'Domaine contacté', en: 'Domain contacted' },
  'bet.candSeenTimes': { fr: 'Vu {n} fois', en: 'Seen {n} times' },
  'bet.candService': { fr: 'Service : {name}', en: 'Service: {name}' },
  'bet.candFirstTest': { fr: 'Voir le premier test', en: 'See the first test' },
  'bet.candContext': {
    fr: 'Contacté pendant le test n° {n} sur {service}.',
    en: 'Contacted during test no. {n} on {service}.',
  },
  'bet.candServiceFallback': { fr: 'le service', en: 'the service' },
  'bet.candDecision': { fr: 'Décision', en: 'Decision' },
  'bet.candAggregatorFor': { fr: 'Agrégateur pour {value}', en: 'Aggregator for {value}' },
  'bet.candLinkTo': { fr: 'Rattacher à un agrégateur…', en: 'Link to an aggregator…' },
  'bet.candLink': { fr: 'Rattacher', en: 'Link' },
  'bet.candNewAggregator': { fr: 'Nouvel agrégateur', en: 'New aggregator' },
  'bet.candNewName': {
    fr: 'Nom du nouvel agrégateur (statut : à qualifier)',
    en: 'Name of the new aggregator (status: to qualify)',
  },
  'bet.candCreateLink': { fr: 'Créer et rattacher', en: 'Create and link' },
  'bet.candIgnore': { fr: "Écarter : ce n'est pas un agrégateur", en: 'Set aside: this is not an aggregator' },

  // Recherche de sites
  'bet.discoveryTitle': { fr: 'Rechercher des sites de paris', en: 'Find betting websites' },
  'bet.discoveryDesc': {
    fr: 'Interroge les sources, compare au catalogue, et propose les sites non encore suivis.',
    en: 'Queries the sources, compares against the catalogue, and proposes websites not yet monitored.',
  },
  'bet.vocabularyLink': { fr: 'Vocabulaire de recherche', en: 'Search vocabulary' },
  'bet.discoveryManagerOnly': {
    fr: 'La recherche est réservée aux responsables. Vous pouvez consulter les résultats déjà importés dans les services de paris.',
    en: 'Searching is restricted to managers. You can still view results already imported under betting services.',
  },
  'bet.pickCountryFirst': {
    fr: 'Choisissez un pays : la recherche est toujours menée pays par pays.',
    en: 'Pick a country: the search is always run country by country.',
  },
  'bet.sourceSearch': { fr: 'Recherche web', en: 'Web search' },
  'bet.sourceSearchCost': { fr: 'consomme le quota mensuel', en: 'uses the monthly quota' },
  'bet.sourceAds': { fr: 'Publicités déjà collectées', en: 'Ads already collected' },
  'bet.sourceAdsCost': { fr: 'relit la base, sans coût', en: 're-reads the database, free' },
  'bet.runPass': { fr: 'Lancer une passe', en: 'Run a pass' },
  'bet.passCost': { fr: 'Cette passe consommera : {cost}.', en: 'This pass will use: {cost}.' },
  'bet.costBudget': {
    fr: ["jusqu'à {n} recherche du quota mensuel", "jusqu'à {n} recherches du quota mensuel"],
    en: ['up to {n} search from the monthly quota', 'up to {n} searches from the monthly quota'],
  },
  'bet.costPerPattern': {
    fr: 'une recherche du quota par modèle de requête actif',
    en: 'one search from the quota per active query template',
  },
  'bet.costNone': { fr: 'aucune recherche consommée', en: 'no search used' },
  'bet.queryBudget': { fr: 'Budget de requêtes', en: 'Query budget' },
  'bet.allPatterns': { fr: 'Tous les modèles', en: 'All templates' },
  'bet.sources': { fr: 'Sources', en: 'Sources' },
  'bet.searching': { fr: 'Recherche en cours…', en: 'Searching…' },
  'bet.runSearch': { fr: 'Lancer la recherche', en: 'Run the search' },
  'bet.countryFollowsHeader': {
    fr: "Le pays suit le filtre de l’en-tête. Retirez-le pour chercher dans un autre pays de votre périmètre.",
    en: 'The country follows the header filter. Clear it to search another country within your scope.',
  },
  'bet.discoveryResultFor': { fr: 'Résultat pour {country}', en: 'Result for {country}' },
  'bet.discoveryResultSub': {
    fr: '{queries} requêtes envoyées, {results} résultats lus, {advertisers} annonceurs relus, {known} domaines déjà au catalogue.',
    en: '{queries} queries sent, {results} results read, {advertisers} advertisers re-read, {known} domains already in the catalogue.',
  },
  'bet.saveJudgements': { fr: 'Enregistrer les jugements', en: 'Save the judgements' },
  'bet.prepareImport': { fr: 'Préparer l’import ({n})', en: 'Prepare the import ({n})' },
  'bet.queriesSent': { fr: 'Requêtes envoyées : {queries}', en: 'Queries sent: {queries}' },
  'bet.judgementsHint': {
    fr: 'Les candidats de cette passe sont déjà consignés. Enregistrez vos jugements pour que les décochés comptent : c’est ce qui mesure le rendement de chaque terme du vocabulaire.',
    en: 'This pass’s candidates are already recorded. Save your judgements so the unticked ones count: that is what measures each vocabulary term’s yield.',
  },
  'bet.judgementsSaved': {
    fr: '{updated} jugements consignés — {kept} retenus, {dropped} écartés.{missing} Le rendement du vocabulaire en tient compte.',
    en: '{updated} judgements recorded — {kept} kept, {dropped} set aside.{missing} The vocabulary yield takes them into account.',
  },
  'bet.judgementsMissing': {
    fr: ' {n} domaines absents du journal : {domains}.',
    en: ' {n} domains missing from the log: {domains}.',
  },
  'bet.importedButNotJudged': {
    fr: 'Import effectué, mais les jugements n’ont pas pu être consignés : {error}',
    en: 'Import done, but the judgements could not be recorded: {error}',
  },
  'bet.noCandidate': {
    fr: 'Aucun site non suivi trouvé. Tous les résultats étaient soit déjà au catalogue, soit écartés par le vocabulaire de recherche.',
    en: 'No unmonitored website found. Every result was already in the catalogue, or set aside by the search vocabulary.',
  },
  'bet.colKeep': { fr: 'Retenir', en: 'Keep' },
  'bet.colProposedName': { fr: 'Nom proposé', en: 'Proposed name' },
  'bet.colWhySurfaced': { fr: 'Ce qui l’a fait remonter', en: 'What surfaced it' },
  'bet.colRejectReason': { fr: 'Motif si écarté', en: 'Reason if set aside' },
  'bet.keepDomain': { fr: 'Retenir {domain}', en: 'Keep {domain}' },
  'bet.likelyReviewSite': { fr: 'Comparateur probable', en: 'Likely comparison site' },
  'bet.candQueries': { fr: 'Requêtes : {queries}', en: 'Queries: {queries}' },
  'bet.candAdvertisers': { fr: 'Annonceurs : {advertisers}', en: 'Advertisers: {advertisers}' },
  'bet.candTerms': { fr: 'Termes imputés : {terms}', en: 'Terms credited: {terms}' },
  'bet.rejectReasonAria': { fr: 'Motif du rejet de {domain}', en: 'Reason for setting aside {domain}' },
  'bet.noReason': { fr: 'Sans motif', en: 'No reason' },
  'bet.reasonComparator': { fr: 'Comparateur ou site d’affiliation', en: 'Comparison or affiliate website' },
  'bet.reasonPress': { fr: 'Presse, blog ou forum', en: 'Press, blog or forum' },
  'bet.reasonNotBetting': { fr: 'Pas un site de paris', en: 'Not a betting website' },
  'bet.reasonWrongCountry': { fr: 'Hors du pays visé', en: 'Outside the target country' },
  'bet.reasonDuplicate': { fr: 'Doublon d’un site déjà suivi', en: 'Duplicate of a website already monitored' },
  'bet.reasonUnreachable': { fr: 'Site inaccessible', en: 'Website unreachable' },
  'bet.provenanceFound': {
    fr: 'Trouvé par la recherche du {date}.',
    en: 'Found by the search of {date}.',
  },
  'bet.provenanceQueries': { fr: 'Requêtes : {queries}', en: 'Queries: {queries}' },
  'bet.provenanceAdvertisers': { fr: 'Annonceurs : {advertisers}', en: 'Advertisers: {advertisers}' },
  'bet.provenanceExcerpt': { fr: 'Extrait : {excerpt}', en: 'Excerpt: {excerpt}' },
  'bet.importPlanTitle': { fr: 'Ce que l’import ferait', en: 'What the import would do' },
  'bet.importPlanSub': {
    fr: 'Rien n’est encore écrit. Relisez, puis confirmez.',
    en: 'Nothing is written yet. Review, then confirm.',
  },
  'bet.confirmImport': { fr: 'Confirmer l’import', en: 'Confirm the import' },
  'bet.importDoneTitle': { fr: 'Import effectué', en: 'Import done' },
  'bet.seeServices': { fr: 'Voir les services', en: 'See the services' },
  'bet.decisionAction.CREATE': { fr: 'Créer', en: 'Create' },
  'bet.decisionAction.ADD_MIRROR': { fr: 'Ajouter en miroir', en: 'Add as mirror' },
  'bet.decisionAction.SKIP': { fr: 'Déjà connu', en: 'Already known' },
  'bet.decisionAction.REJECT': { fr: 'Refusé', en: 'Rejected' },
  'bet.noEntryKept': { fr: 'Aucune entrée retenue.', en: 'No entry kept.' },

  // Référentiels
  'bet.referentialsTitle': { fr: 'Référentiels', en: 'Reference data' },
  'bet.referentialsDesc': {
    fr: 'Ce qui permet de qualifier un test : qui est autorisé à encaisser, et sur quels réseaux les tests sont faits.',
    en: 'What makes a test qualifiable: who may collect payments, and on which networks the tests are run.',
  },
  'bet.aggregatorsTitle': { fr: 'Agrégateurs de paiement', en: 'Payment aggregators' },
  'bet.aggregatorsSub': {
    fr: '{n} agrégateurs · {authorized} autorisés · {unauthorized} non autorisés · {unknown} à qualifier',
    en: '{n} aggregators · {authorized} authorised · {unauthorized} not authorised · {unknown} to qualify',
  },
  'bet.importIntouchList': { fr: 'Importer la liste InTouch', en: 'Import the InTouch list' },
  'bet.filterByStatus': { fr: 'Filtrer par statut', en: 'Filter by status' },
  'bet.aggAuthorizedPl': { fr: 'Autorisés', en: 'Authorised' },
  'bet.aggUnauthorizedPl': { fr: 'Non autorisés', en: 'Not authorised' },
  'bet.aggUnknownPl': { fr: 'À qualifier', en: 'To qualify' },
  'bet.colAggregator': { fr: 'Agrégateur', en: 'Aggregator' },
  'bet.colKnownDomains': { fr: 'Domaines reconnus', en: 'Known domains' },
  'bet.colSmsNames': { fr: 'Noms dans les SMS', en: 'Names in SMS' },
  'bet.aggFormEdit': { fr: 'Modifier {name}', en: 'Edit {name}' },
  'bet.aggFormNew': { fr: 'Ajouter un agrégateur', en: 'Add an aggregator' },
  'bet.aggCountriesField': {
    fr: "Pays où ce statut s'applique (codes séparés par des virgules, vide = tous)",
    en: 'Countries where this status applies (comma-separated codes, empty = all)',
  },
  'bet.aggDomainsField': { fr: 'Domaines reconnus (un par ligne)', en: 'Known domains (one per line)' },
  'bet.aggNamesField': {
    fr: 'Noms de bénéficiaire dans les SMS (un par ligne)',
    en: 'Payee names in SMS messages (one per line)',
  },
  'bet.importAggTitle': { fr: 'Importer la liste des agrégateurs', en: 'Import the aggregator list' },
  'bet.importAggSubmit': { fr: ['Importer {n} agrégateur', 'Importer {n} agrégateurs'], en: ['Import {n} aggregator', 'Import {n} aggregators'] },
  'bet.importAggDone': {
    fr: 'Import terminé : {created} agrégateurs créés, {updated} complétés. Les domaines et noms existants ont été conservés.',
    en: 'Import complete: {created} aggregators created, {updated} completed. Existing domains and names were kept.',
  },
  'bet.importAggHelp': {
    fr: 'Une ligne par agrégateur, colonnes séparées par des points-virgules : nom;statut;pays;domaines;noms dans les SMS. Statut : autorisé, non autorisé ou à qualifier. Plusieurs valeurs dans une colonne : séparées par des virgules. Un agrégateur déjà présent est complété, jamais écrasé.',
    en: 'One line per aggregator, columns separated by semicolons: name;status;countries;domains;SMS names. Status: authorised, not authorised or to qualify. Several values in one column: separate them with commas. An aggregator already present is completed, never overwritten.',
  },
  'bet.importAggAria': { fr: 'Liste à importer', en: 'List to import' },
  // Exemple collable : les mots de statut doivent être ceux que le lecteur
  // accepte dans sa langue, sinon l'exemple ne marche pas.
  'bet.importAggPlaceholder': {
    fr: 'nom;statut;pays;domaines;noms dans les SMS\nCinetPay;autorisé;CI,SN;cinetpay.com;CINETPAY\nMinerve Tech;non autorisé;GA,CM;;TECH MINERVE TECH',
    en: 'name;status;countries;domains;SMS names\nCinetPay;AUTHORIZED;CI,SN;cinetpay.com;CINETPAY\nMinerve Tech;UNAUTHORIZED;GA,CM;;TECH MINERVE TECH',
  },
  'bet.importAggReady': { fr: ['{n} ligne prête', '{n} lignes prêtes'], en: ['{n} row ready', '{n} rows ready'] },
  'bet.importAggIgnored': { fr: ['{n} ignorée', '{n} ignorées'], en: ['{n} ignored', '{n} ignored'] },
  'bet.importAggRowError': { fr: 'Ligne {line} : {error}', en: 'Row {line}: {error}' },
  'bet.importAggNoName': { fr: 'Nom manquant', en: 'Name missing' },
  'bet.importAggBadStatus': { fr: 'Statut « {status} » non reconnu', en: 'Status “{status}” not recognised' },
  'bet.carriersTitle': { fr: 'Opérateurs télécom', en: 'Mobile carriers' },
  'bet.carriersSub': {
    fr: 'Réseaux sur lesquels les agents réalisent les tests',
    en: 'Networks on which agents run the tests',
  },
  'bet.carrierCountryAria': { fr: "Pays de l'opérateur", en: 'Carrier’s country' },
  'bet.carrierNameAria': { fr: "Nom de l'opérateur", en: 'Carrier name' },
  'bet.addCarrier': { fr: 'Ajouter un opérateur', en: 'Add a carrier' },
  'bet.removeCarrier': { fr: 'Retirer {name}', en: 'Remove {name}' },

  // Vocabulaire de recherche
  'bet.termsTitle': { fr: 'Vocabulaire de la recherche de sites', en: 'Website search vocabulary' },
  'bet.termsSub': {
    fr: ['{n} termes · {queries} requête active', '{n} termes · {queries} requêtes actives'],
    en: ['{n} terms · {queries} active query', '{n} terms · {queries} active queries'],
  },
  'bet.addTerm': { fr: 'Ajouter un terme', en: 'Add a term' },
  'bet.termFamily': { fr: 'Famille de termes', en: 'Term family' },
  'bet.termKind.QUERY': { fr: 'Requêtes', en: 'Queries' },
  'bet.termKind.QUERY.hint': {
    fr: "Envoyées au moteur de recherche. Écrivez {token} là où le nom du pays doit apparaître. Chaque requête consomme une recherche du quota mensuel.",
    en: 'Sent to the search engine. Write {token} where the country name should appear. Each query uses one search from the monthly quota.',
  },
  'bet.termKind.BETTING_SIGNAL': { fr: 'Mots de reconnaissance', en: 'Recognition words' },
  'bet.termKind.BETTING_SIGNAL.hint': {
    fr: "Un résultat n'est retenu que si son titre, son extrait ou son domaine contient l'un de ces mots.",
    en: 'A result is kept only when its title, snippet or domain contains one of these words.',
  },
  'bet.termKind.REVIEW_SIGNAL': { fr: 'Mots de comparateur', en: 'Comparison-site words' },
  'bet.termKind.REVIEW_SIGNAL.hint': {
    fr: "Signalent un site d'avis ou d'affiliation : le candidat est conservé, mais relégué en fin de liste.",
    en: 'They flag a review or affiliate website: the candidate is kept, but pushed to the end of the list.',
  },
  'bet.termKind.NOISE_DOMAIN': { fr: 'Domaines écartés', en: 'Excluded domains' },
  'bet.termKind.NOISE_DOMAIN.hint': {
    fr: 'Jamais un opérateur : presse, réseaux sociaux, hébergeurs de pages. Écrivez le domaine racine.',
    en: 'Never an operator: press, social media, page hosts. Write the root domain.',
  },
  'bet.termKindCount': { fr: '{label} ({n})', en: '{label} ({n})' },
  'bet.yieldNothing': { fr: 'Rien remonté', en: 'Nothing surfaced' },
  'bet.yieldNoneJudged': {
    fr: ['{n} remonté, aucun jugé', '{n} remontés, aucun jugé'],
    en: ['{n} surfaced, none judged', '{n} surfaced, none judged'],
  },
  'bet.yieldRate': {
    fr: '{rate} % ({imported} retenus / {decided} jugés{pending})',
    en: '{rate}% ({imported} kept / {decided} judged{pending})',
  },
  'bet.yieldPending': { fr: ', {n} en attente', en: ', {n} pending' },
  'bet.yieldExplain': {
    fr: 'Rendement : part des candidats jugés qui ont été retenus. {candidates} candidats consignés, dont {pending} encore à juger{noReason}. Un taux se lit avec le nombre de jugements qui le portent, jamais seul.',
    en: 'Yield: the share of judged candidates that were kept. {candidates} candidates recorded, {pending} still to judge{noReason}. A rate is read together with the number of judgements behind it, never alone.',
  },
  'bet.yieldNoReason': { fr: ' et {n} écartés sans motif', en: ' and {n} set aside without a reason' },
  'bet.noActiveSignal': {
    fr: 'Aucun mot de reconnaissance actif : la recherche ne retiendra aucun site tant qu’il n’y en a pas au moins un.',
    en: 'No active recognition word: the search will keep no website until there is at least one.',
  },
  'bet.colTerm': { fr: 'Terme', en: 'Term' },
  'bet.colState': { fr: 'État', en: 'State' },
  'bet.colYield': { fr: 'Rendement', en: 'Yield' },
  'bet.colNote': { fr: 'Note', en: 'Note' },
  'bet.active': { fr: 'Actif', en: 'Active' },
  'bet.inactive': { fr: 'Inactif', en: 'Inactive' },
  'bet.allCountriesShort': { fr: 'Tous', en: 'All' },
  'bet.noTermInFamily': { fr: 'Aucun terme dans cette famille.', en: 'No term in this family.' },
  'bet.termFormEdit': { fr: 'Modifier « {value} »', en: 'Edit “{value}”' },
  'bet.termFormNew': { fr: 'Ajouter un terme', en: 'Add a term' },
  'bet.family': { fr: 'Famille', en: 'Family' },
  'bet.rootDomain': { fr: 'Domaine racine', en: 'Root domain' },
  'bet.term': { fr: 'Terme', en: 'Term' },
  'bet.termLiteralHint': {
    fr: "Le terme est cherché tel quel, jamais comme une expression régulière. Le pluriel du dernier mot est accepté, et un nombre peut s’intercaler : « top sites » reconnaît « top 10 sites ».",
    en: 'The term is searched literally, never as a regular expression. The last word’s plural is accepted, and a number may sit in between: “top sites” matches “top 10 sites”.',
  },
  'bet.termQueryPlaceholder': { fr: 'paris sportifs en ligne {token}', en: 'online sports betting {token}' },
  'bet.termNoisePlaceholder': { fr: 'exemple.com', en: 'example.com' },
  'bet.termSignalPlaceholder': { fr: 'bookmaker', en: 'bookmaker' },
  'bet.termCountriesField': {
    fr: 'Pays concernés (codes séparés par des virgules, vide = tous)',
    en: 'Countries concerned (comma-separated codes, empty = all)',
  },
} satisfies Bundle
